<script>
  import { tl } from "./multilang.js"; 
</script>

<section class=" has-background-grey-lightest ">
  <div class="container">

    <div class="hero is-warning">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-1 has-text-centered">{tl("Page not found")}</h1>
        </div>
      </div>
    </div>

  </div>
</section>
